import script from "./inputRange.vue?vue&type=script&setup=true&lang=js"
export * from "./inputRange.vue?vue&type=script&setup=true&lang=js"

import "./inputRange.vue?vue&type=style&index=0&id=ac6e0bde&lang=less&scoped=true"

import exportComponent from "C:\\Users\\11920\\Desktop\\vue_db\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac6e0bde"]])

export default __exports__